import { render, staticRenderFns } from "./the-desktop-background.vue?vue&type=template&id=ad3a34e8&scoped=true&"
import script from "./the-desktop-background.vue?vue&type=script&lang=js&"
export * from "./the-desktop-background.vue?vue&type=script&lang=js&"
import style0 from "./the-desktop-background.vue?vue&type=style&index=0&id=ad3a34e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3a34e8",
  null
  
)

export default component.exports